/**
 * Query params for service relations.
 * Note: relation indexes intentionally follow backend expectation.
 */
export const SERVICE_RELATIONS = {
  'relations[0]': 'author',
  'relations[2]': 'status',
};

export const buildServiceRelationParams = () => ({ ...SERVICE_RELATIONS });
